angular.module('core')
    .constant("DBL_STATUS_CONSTANTS", {
        'CONGRATULATE': 1,
        'WARN': 2
    })
    .service('dblUsageStatus', ['DBL_STATUS_CONSTANTS', 'authentication', function(STATUS, authentication) {
        var service = {
            getStatusString: function(status) {
                switch (status) {
                    case STATUS.CONGRATULATE:
                        return 'congratulate';
                    case STATUS.WARN:
                      var customerIsAdmin = authentication.getCustomer().isAdmin;
                      if (customerIsAdmin !== null && customerIsAdmin) {
                        // https://dreambox.atlassian.net/browse/IN-4563 --> do not return red in views for admins
                        return 'normal';
                      } else {
                        return 'warn';
                      }
                      break;
                    default:
                        return 'normal';
                }
            },
            getUsageTimeHoverMessage: function(status) {
                switch (status) {
                    case STATUS.CONGRATULATE:
                        return 'The student has excellent usage of over 45 minutes per week.';
                    case STATUS.WARN:
                        return 'This is displayed as orange as the student is below the recommended minimum weekly usage of 15 minutes per week.';
                    default:
                        return 'The student is meeting the recommended minimum usage of 15 minutes per week.';
                }
            },
            getUsageLessonsHoverMessage: function(status) {
                switch (status) {
                    case STATUS.CONGRATULATE:
                        return 'The student has excellent usage of over 5 lessons per week.';
                    case STATUS.WARN:
                        return 'This is displayed as orange as the student is below the recommended minimum weekly usage of 2 lessons per week.';
                    default:
                        return 'The student is meeting the recommended minimum usage of 2 lessons per week.';
                }
            }
        };

        return service;
    }]);
